import React from "react";
import LineChart from "../../../../Components/GraphNCharts/LineChart";
import styles from "../../../../styles/scope3/Dashboard/transportation.module.css";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import { Typography } from "@mui/material";
import { monthSort } from "../../../../utils/constant";
import {
  fixedPercentage,
  fixedTons,
  formatNumberCommaSeparated,
  truncateNumber,
} from "../../../../utils/common";

const CarbonIntensity = ({ filter, setFilter, carbon }) => {
  console.log(
    carbon?.monthlyData
      ?.flatMap(
        (el) =>
          el?.monthlyData
            ?.map((e) => {
              const intensity =
                filter === "Distance" ? e?.distanceIntensity : e?.loadIntensity;
              return fixedTons(intensity || 0);
            })
            ?.filter(Boolean) || []
      )
      ?.filter(Boolean),

    "linechart"
  );
  const createLinechartDataset = (labels, colors, data) => {
    const dataSet = labels?.map((el, i) => ({
      label: el,
      data: labels?.length > 1 ? data[i] : data,
      borderColor: colors[i],
      backgroundColor: colors[i],
      tension: 0.4,
      fill: true,
      pointBorderColor: "#fff",
      pointRadius: 0,
    }));
    console.log(";ine", dataSet, data, colors, labels);
    return dataSet;
  };

  return (
    <div className={styles.cards}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: 3,
        }}
      >
        <div style={{ width: "80%" }}>
          <p className={styles.emission_heading}>
            Carbon Intensity (Distance vs Load) :
            <span className={styles.emission_heading_span}>
              {(() => {
                const value =
                  filter === "Distance"
                    ? carbon?.distanceValue
                    : carbon?.loadValue;
                const change =
                  filter === "Distance"
                    ? carbon?.distanceChange
                    : carbon?.loadChange;
                const color = change >= 0 ? "#00C851" : "red";
                const sign = change >= 0 ? "+" : "";

                return (
                  <>
                    {formatNumberCommaSeparated(fixedTons(value ?? 0))} unit
                    <span
                      className={styles.emission_heading_percent}
                      style={{ color, marginLeft: "0.2rem" }}
                    >
                      {" "}
                      ({sign}
                      {fixedPercentage(change)}% YOY{" "}
                      {change >= 0 ? (
                        <TrendingUpIcon sx={{ fontSize: "18px" }} />
                      ) : (
                        <TrendingDownIcon sx={{ fontSize: "18px" }} />
                      )}
                      )
                    </span>
                  </>
                );
              })()}
            </span>
          </p>
        </div>
        <div>
          <Typography style={{ fontSize: "12px" }}>Filter by : </Typography>
          <select
            name="Carbon Intensity"
            id="month"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className={styles.heading_select_month}
            style={{ width: "6rem", mt: "5px" }}
          >
            {["Distance", "Load"].map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </select>
        </div>
      </div>
      <LineChart
        dataset={
          carbon?.monthlyData
            ?.flatMap(
              (el) =>
                el?.monthlyData
                  ?.map((e) => {
                    const intensity =
                      filter === "Distance"
                        ? e?.distanceIntensity
                        : e?.loadIntensity;
                    return fixedTons(intensity || 0);
                  })
                  ?.filter(Boolean) || []
            )
            ?.filter(Boolean)
            ?.filter(Boolean)?.length > 0
            ? createLinechartDataset(
                carbon?.monthlyData?.map((el) => el?.category),
                ["blue", "red"],
                carbon?.monthlyData?.map((el) =>
                  el?.monthlyData?.map((e) =>
                    filter === "Distance"
                      ? e?.distanceIntensity || 0
                      : e?.loadIntensity || 0
                  )
                )
              )
            : []
        }
        labels={carbon?.monthlyData?.[0]?.monthlyData?.map(
          (el) => monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
        )}
        display={true}
        yAxisTitle={"Emissions (tCO2e)"}
        customWidth={410} // Optional custom width
        customHeight={250} // Optional custom height
      />
    </div>
  );
};

export default CarbonIntensity;
